module.exports = __webpack_public_path__ + "img/logo.8cf06da4.png";